<template>
  <InvoiceParameterDefaultModal
    title="Regras Relacionadas Encontradas"
    width="900"
    showOctagon
    :show="show">
    <template slot="icon">
    </template>
    <template slot="body">
      <div>
        <TextBase>
          Foram encontradas regras ativas com essa combinação de filtros, porém em níveis diferentes da hierarquia.
        </TextBase>
        <TextBase>
          A nova regra será aplicada conforme a prioridade definida.
        </TextBase>

        <v-divider class="my-4" />
      </div>
      <v-data-table
        hide-default-footer
        mobile-breakpoint="0"
        :headers="headers"
        :items="[{}, {}]">
        <template
          v-slot:[`header.type`]>
          <Header>Tipo de Nível</Header>
        </template>
        <template
          v-slot:[`header.entity`]>
          <Header>Opção do Nível</Header>
        </template>
        <template
          v-slot:[`header.rule`]>
          <Header>Regra</Header>
        </template>
        <template
          v-slot:[`header.description`]>
          <Header>Descrição</Header>
        </template>
        <template
          v-slot:[`header.value`]>
          <Header>Valor</Header>
        </template>
        <template
          v-slot:[`header.status`]>
          <Header>Status</Header>
        </template>
        <template
          v-slot:[`header.action`]>
          <Header>Ação</Header>
        </template>

        <template
          v-slot:[`item.action`]="{ item }">
          <div class="fill-height d-flex align-center justify-center">
            <v-tooltip
              top>
              <template v-slot:activator="{on, attrs}">
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  color="primary"
                  size="16">
                  fas fa-pen
                </v-icon>
              </template>
              Editar
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-sheet
        class="fill-width mt-5 rounded-lg pa-4"
        height="90"
        color="scroll-background"
        style="color: var(--v-info-base)">
        <span class="font-weight-bold d-block ui-text-lg">
          Observação:
        </span>
        <span class="d-block ui-text-base">
          A nova regra que você está criando terá prioridade conforme a hierarquia definida pelo sistema.
        </span>
      </v-sheet>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-end gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          outlined>
          Fechar
        </v-btn>
        <v-btn
          class="action-button-modal"
          color="primary">
          Continuar com a Criação da Nova Regra
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterHeader from '../components/InvoiceParameterHeader.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
export default {
  name: "RelatedRulesModal",
  components: {
    InvoiceParameterDefaultModal,
    Header: InvoiceParameterHeader,
    TextBase: InvoiceParameterText
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
  computed: {
    headers() {
      return [
        { value: 'type', sortable: false },
        { value: 'entity', sortable: false },
        { value: 'rule', sortable: false },
        { value: 'description', sortable: false },
        { value: 'value', sortable: false },
        { value: 'status', sortable: false },
        { value: 'action', width: '60px', sortable: false, align: 'center' },
      ];
    },
  }
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>